import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';

import { User }  from '../user/user';
import { Utils } from '../utils/utils';
import { IPTV }  from '../iptv/iptv';


/*
*
*  Fav (Favorite but the name is already taken by page) Provider
*
*/

@Injectable()
export class Deeplink {

    public route : string = '';
    public disableSourceChange : boolean = false;
    public disableResolutionChange : boolean = false;
    public awaitingDeeplink : string;

    public refreshFavorites : boolean = false;

    constructor(
        public events: Events,
        public user: User,
        public IPTV: IPTV,
        public utils: Utils
    ) { }

    setRoute(route) {
        this.route = route;
        this.route = this.route.trim();
    }

    ready() {
        return new Promise((resolve, reject) => {
            
            if (!this.route) {
                resolve();
                return;
            }

            let that = this;

            let interval = setInterval(function() {

                if (that.route) {
                    clearInterval(interval);
                    that.process().then(() => {
                        resolve();
                    });
                }
            },100);
           
        });
    }

    process() {
        return new Promise((resolve, reject) => {

            // Not connected
            if (!localStorage.getItem('token')) { this.deeplinkSuccess(); resolve(); return; }

            // No route
            if (!this.route) { resolve(); return; }

            // Route did not concern
            if (this.route.search('cmd') < 0) { this.deeplinkSuccess(); resolve(); return; }

            console.log('Deeplink::process()');

            // Reset refresher
            this.refreshFavorites = false;

            // Count how many actions did we need to proceed 
            let nbActions = 0;

            if (this.getCMD('source')) nbActions++;
            if (this.getCMD('resolution')) nbActions++;
            if (this.getCMD('disable_source') && this.getCMD('disable_source') == 'true') nbActions++;
            if (this.getCMD('disable_resolution') && this.getCMD('disable_resolution') == 'true') nbActions++;
            if (this.getCMD('disable_source') && this.getCMD('disable_source') == 'false') nbActions++;
            if (this.getCMD('disable_resolution') && this.getCMD('disable_resolution') == 'false') nbActions++;
            if (this.getCMD('disconnect') && this.getCMD('disconnect') == 'true') nbActions++;

            // No actions
            if (!nbActions) { this.deeplinkSuccess(); resolve(); return; }

            // Count how many we did
            let nbDone = 0;

            // Source change 
            if (this.getCMD('source')) {

                // Check if already in this source
                if (this.IPTV.box.manufacturer == this.getCMD('source')) {
                    nbDone++;
                    if (nbDone==nbActions) { this.deeplinkSuccess(); resolve(); return; }
                } else {

                    // Check if we find source
                    let findSource = false;
                    for (let _box of this.IPTV.boxs) {
                        if ( _box.manufacturer == this.getCMD('source')) {
                            findSource = true;

                            this.utils.load();

                            this.IPTV.setSource(_box.id).then(() => {
                                nbDone++;
                                if (nbDone==nbActions) { 
                                    this.refreshFavorites = true;
                                    this.deeplinkSuccess(); 
                                    resolve(); 
                                    return; 
                                }
                            });
                        }
                    }

                    if (!findSource) {
                        nbDone++;
                        if (nbDone==nbActions) { this.deeplinkSuccess(); resolve(); return; }
                    }
                }
            }

            // Resolution change
            if (this.getCMD('resolution')) {

                // Check if already in this source
                if (this.IPTV.resolution.name_tech == this.getCMD('resolution')) {
                    nbDone++;
                    if (nbDone==nbActions) { this.utils.unload(); resolve(); return; }
                } else {

                    // Check if we find resolution
                    let findResolution = false;
                    for (let _resolution of this.IPTV.contract.resolutions) {
                        if ( _resolution.name_tech == this.getCMD('resolution')) {
                            findResolution = true;
                                
                            this.utils.load();

                            this.IPTV.setResolution(_resolution.id).then(() => {
                                nbDone++;
                                if (nbDone==nbActions) {
                                    this.deeplinkSuccess(); resolve(); return; 
                                }
                            });
                        }
                    }
    
                    if (!findResolution) {
                        nbDone++;
                        if (nbDone==nbActions) { this.deeplinkSuccess(); resolve(); return; }
                    }
                }
            }

            // Permission to change source
            if (this.getCMD('disable_source') && this.getCMD('disable_source') == 'true') {
                this.disableSourceChange = true;

                nbDone++;
                if (nbDone==nbActions) { this.refreshFavorites = true; this.deeplinkSuccess(); resolve(); return; }
            }

            // Permission to change resolution 
            if (this.getCMD('disable_resolution') && this.getCMD('disable_resolution') == 'true') {
                this.disableResolutionChange = true;

                nbDone++;
                if (nbDone==nbActions) { this.deeplinkSuccess(); resolve(); return; }
            }

            // Permission to change source
            if (this.getCMD('disable_source') && this.getCMD('disable_source') == 'false') {
                this.disableSourceChange = false;

                nbDone++;
                if (nbDone==nbActions) { this.refreshFavorites = true; this.deeplinkSuccess(); resolve(); return; }
            }

            // Permission to change resolution 
            if (this.getCMD('disable_resolution') && this.getCMD('disable_resolution') == 'false') {
                this.disableResolutionChange = false;

                nbDone++;
                if (nbDone==nbActions) { this.deeplinkSuccess(); resolve(); return; }
            }

            // Force Disconnect
            if (this.getCMD('disconnect') && this.getCMD('disconnect') == 'true') {
                this.events.publish('user:forceDisconnect');

                nbDone++;
                if (nbDone==nbActions) { this.deeplinkSuccess(); resolve(); return; }
            }
        });
    }

    deeplinkSuccess() {
        if (this.refreshFavorites) {
            this.events.publish('favorite:refreshCache'); 
            this.events.publish('favoriteApp:refreshCache'); 
        }
        this.events.publish('live:success');
        this.IPTV.isRemoting = false;
        this.utils.unload();
    }

    getCMD(name) {
        let url = this.route;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

}


// WEBPACK FOOTER //
// ./src/providers/deeplink/deeplink.ts